module.exports = __webpack_public_path__ + "img/we3.903c990a.svg";